// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash/fp';

import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import localizer from 'share/localization/Izenda.Localizer';
import Schedule from 'modules/Subscription/Izenda.Schedule';
import SubscriptionDetails from "logic/models/Izenda.SubscriptionDetails";

@connect()
export default class WorkspaceSchedulePopup extends Component {

  static propTypes = {
    workspaceDetail: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const workspaceDetail = props.workspaceDetail;

    let scheduleData = new SubscriptionDetails();
    if (!isNil(workspaceDetail && workspaceDetail.copySchedule)) {
      scheduleData = workspaceDetail.copySchedule;
    }

    this.state = {
      scheduleData: scheduleData
    };
  }

  deleteSchedule = () => {
    const { workspaceDetail } = this.props;
    workspaceDetail.setCopySchedule(null);
    this.props.onAccept(null);
  };

  onClosing = (cb, type) => {
    const { scheduleData } = this.state;
    const { workspaceDetail } = this.props;
    switch (type) {
      case 'accept':
        workspaceDetail.setCopySchedule(scheduleData);
        this.props.onAccept(scheduleData);
        break;
      case 'cancel':
        this.props.onReject();
        break;
    }
  };

  onValidateSubscription = (data) => {

  };

  render() {
    const { scheduleData } = this.state;
    return (
      <Popup visible onClosing={this.onClosing} autoClose={false} type="none">
        <Popup.Header title={localizer.getText('COPY_MANAGEMENT_TITLE_POPUP_CONFIGURE_SCHEDULE')}/>
        <Popup.Body>
          <div className="u_fullSize" style={{height: '300px'}}>
            <Schedule
              data={scheduleData}
              onValidateSubscription={this.onValidateSubscription}
              isSubscriptionTypeHidden
            />
          </div>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton className="btn-report-default" onClick={this.deleteSchedule}>
            {localizer.getText('COMMON_LABEL_DELETE')}
          </Popup.ConfirmationButton>
          <Popup.ConfirmationButton type="accept">
            {localizer.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
          <Popup.ConfirmationButton type="cancel">
            {localizer.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/Schedule/Izenda.WorkspaceSchedulePopup.js